








import { defineComponent } from '@vue/composition-api';

import useDelivery from '@/useDelivery';

const DeliveryStatusRenderer = defineComponent({
  props: {
    status: { type: String, required: true },
    reason: { type: String, required: false },
  },
  setup(props) {
    const { shipmentStatusClassMap, translate } = useDelivery();

    return {
      translate,
      shipmentStatusClassMap,
    };
  },
});

export default DeliveryStatusRenderer;
